<template>
    <div class="desktop-view-form">
        <flex-container
            direction="column"
            :padding="Size.md"
            :gap="Size.md"
        >
            <flex-container
                justify-content="space-between"
                align-items="center"
                no-wrap
            >
                <text-heading sub>
                    {{ showDesktop ? 'Desktop' : 'Mobiele' }} weergave
                </text-heading>
                <input-group v-model="showDesktop" inline>
                    <template #input>
                        <toggle-input>
                            <template #labelActive>
                                <svg-icon :icon="DesktopIcon" />
                            </template>
                            <template #labelInactive>
                                <svg-icon :icon="MobileIcon" />
                            </template>
                        </toggle-input>
                    </template>
                </input-group>
            </flex-container>

            <card-normal without-padding>
                <div :class="['desktop-view-form__layout', widgetPosition.value]">
                    <template v-if="isWidgetTypeIcon">
                        <svg-icon
                            :icon="iconForVariant(widgetVariation.value)"
                            :size="IconSize.xl"
                            :style="tiltIcon(widgetVariation, widgetPosition)"
                            :color="assistent.widget.color"
                            is-custom-icon
                        />
                    </template>
                    <template v-else>
                        <div :style="{ color: assistent.widget.color, width: '100%' }">
                            <floating-beam-icon fill="'primary'" />
                        </div>
                    </template>
                </div>
            </card-normal>

            <flex-container
                size="full"
                :screen-sizes="{
                    desktop: 6,
                }"
            >
                <card-normal>
                    <text-heading sub>
                        Widget stijl
                    </text-heading>
                    <flex-container>
                        <input-group v-model="widgetType" inline>
                            <template #input>
                                <radio-group-input :items="WidgetType.values" :columns="2">
                                    <template #default="{ bindings }">
                                        <text-decorator>
                                            {{ bindings.item.label }}
                                        </text-decorator>
                                    </template>
                                </radio-group-input>
                            </template>
                        </input-group>
                    </flex-container>
                </card-normal>
            </flex-container>

            <template v-if="isWidgetTypeIcon">
                <flex-container
                    size="full"
                    :screen-sizes="{
                        desktop: 6,
                    }"
                >
                    <card-normal>
                        <text-heading sub>
                            {{ showDesktop ? 'Desktop' : 'Mobiele' }} stijl
                        </text-heading>
                        <flex-container>
                            <input-group v-model="widgetVariation" inline>
                                <template #input>
                                    <radio-group-input :items="Variant.values" :columns="2">
                                        <template #default="{ bindings }">
                                            <svg-icon
                                                :icon="iconForVariant(bindings.item.value)"
                                                :size="IconSize.xl"
                                                :color="assistent.widget.color"
                                                is-custom-icon
                                            />
                                        </template>
                                    </radio-group-input>
                                </template>
                            </input-group>
                        </flex-container>
                    </card-normal>
                </flex-container>

                <flex-container
                    size="full"
                    :screen-sizes="{
                        desktop: 6,
                    }"
                >
                    <card-normal>
                        <text-heading sub>
                            {{ showDesktop ? 'Desktop' : 'Mobiele' }} positie
                        </text-heading>
                        <flex-container>
                            <input-group
                                v-model="widgetPosition"
                                inline
                            >
                                <template #input>
                                    <image-radio-group-input
                                        :columns="3"
                                        :svg="true"
                                        :items="[
                                            Position.TOP_RIGHT,
                                            Position.TOP_LEFT,
                                            Position.RIGHT,
                                            Position.LEFT,
                                            Position.BOTTOM_RIGHT,
                                            Position.BOTTOM_LEFT,
                                        ]"
                                        :images="[
                                            TopRightIcon,
                                            TopLeftIcon,
                                            MiddleRightIcon,
                                            MiddleLeftIcon,
                                            BottomRightIcon,
                                            BottomLeftIcon,
                                        ]"
                                        value-key-name="value"
                                        image-key-name="image"
                                    />
                                </template>
                            </input-group>
                        </flex-container>
                    </card-normal>
                </flex-container>
            </template>

            <template v-else>
                <!-- Floating Beam -->
                <flex-container
                    size="full"
                    :screen-sizes="{
                        desktop: 6,
                    }"
                >
                    <card-normal>
                        <text-heading sub>
                            {{ showDesktop ? 'Desktop' : 'Mobiele' }} positie
                        </text-heading>
                        <flex-container size="auto">
                            <input-group
                                v-model="widgetPosition"
                                inline
                            >
                                <template #input>
                                    <image-radio-group-input
                                        :columns="4"
                                        :svg="true"
                                        :color="'primary'"
                                        :items="[
                                            Position.TOP_LEFT,
                                            Position.TOP_RIGHT,
                                            Position.BOTTOM_LEFT,
                                            Position.BOTTOM_RIGHT,
                                        ]"
                                        :images="[
                                            BeamTopLeftIcon,
                                            BeamTopRightIcon,
                                            BeamBottomLeftIcon,
                                            BeamBottomRightIcon,
                                        ]"
                                        value-key-name="value"
                                        image-key-name="image"
                                    />
                                </template>
                            </input-group>
                        </flex-container>
                    </card-normal>
                </flex-container>

                <flex-container
                    size="full"
                    :screen-sizes="{
                        desktop: 6,
                    }"
                >
                    <card-normal>
                        <flex-container>
                            <input-group v-model="assistent.widget.beamReopenLabel">
                                <template #label>
                                    <text-heading sub>
                                        Widget labelnaam
                                    </text-heading>
                                </template>
                                <template #input>
                                    <text-input />
                                </template>
                            </input-group>
                        </flex-container>
                    </card-normal>
                </flex-container>

                <flex-container
                    v-if="floatingBeamPositionTop"
                    size="full"
                    :screen-sizes="{
                        desktop: 6,
                    }"
                >
                    <card-normal>
                        <flex-container>
                            <input-group
                                v-model.number="beamOpenPercentage"
                                :schema="number().required().moreThan(0).positive()"
                            >
                                <template #label>
                                    <text-heading sub>
                                        Verschijnt na percentage van bovenkant
                                    </text-heading>
                                </template>
                                <template #input>
                                    <text-input />
                                </template>
                            </input-group>
                        </flex-container>
                    </card-normal>
                </flex-container>
            </template>

            <flex-container
                size="full"
                :screen-sizes="{
                    desktop: 6,
                }"
            >
                <card-normal>
                    <flex-container>
                        <text-heading sub>
                            Chatdialoog stijl
                        </text-heading>
                        <button-plain-icon
                            :icon="SquareInfoIcon"
                            :size="IconSize.sm"
                            is-custom-icon
                            @click="chatDialogInfo?.toggleOverlay()"
                        />
                    </flex-container>
                    <flex-container>
                        <input-group v-model="chatStyle" inline>
                            <template #input>
                                <radio-group-input :items="ChatStyle.values" :columns="2">
                                    <template #default="{ bindings }">
                                        <text-decorator>
                                            {{ bindings.item.label }}
                                        </text-decorator>
                                    </template>
                                </radio-group-input>
                            </template>
                        </input-group>
                    </flex-container>
                </card-normal>
            </flex-container>
        </flex-container>
    </div>

    <modal-dialog
        ref="chatDialogInfo"
        label="asdf"
        description="Preview van de chatdialoog stijlen"
        :size="5"
    >
        <template #default>
            <flex-container>
                <text-heading>Chatdialoog stijl</text-heading>
                <grid-container template="two-columns">
                    <div>
                        <img
                            src="@/ai/assistent/assets/features/chat-display-flat.png"
                            alt="Voorbeeld"
                            class="chat-dialog-style-image"
                        />
                        <text-description>
                            Flat weergave
                        </text-description>
                    </div>
                    <div>
                        <img
                            src="@/ai/assistent/assets/features/chat-display-modern.png"
                            alt="Voorbeeld"
                            class="chat-dialog-style-image"
                        />
                        <text-description>
                            Moderne weergave
                        </text-description>
                    </div>
                </grid-container>
            </flex-container>
        </template>
        <template #footer="{ bindings }">
            <dialog-footer>
                <button-block without-loading @click="bindings.overlay.closeOverlay();">
                    Verder
                </button-block>
            </dialog-footer>
        </template>
    </modal-dialog>
</template>

<script setup lang="ts">
    import {
        type ExposedOverlay,
        FlexContainer,
        IconSize,
        ImageRadioGroupInput,
        InputGroup,
        RadioGroupInput,
        Size,
        SvgIcon,
        ToggleInput,
    } from '@keyvue/one-ui';
    import { computed, type Ref, ref, watch } from 'vue';
    import { type Assistent, ChatStyle, Position, Variant, WidgetType } from '@keyvue/one-api-client';
    import RoundedSquareIcon from '@/ai/assistent/assets/icons/assistant/rounded_square.svg?component';
    import CorneredCircleIcon from '@/ai/assistent/assets/icons/assistant/cornered_circle.svg?component';
    import BubbleIcon from '@/ai/assistent/assets/icons/assistant/bubble.svg?component';
    import ChatButtonIcon from '@/ai/assistent/assets/icons/assistant/chatbutton.svg?component';
    import TopRightIcon from '@/ai/assistent/assets/icons/assistant/position_tr.svg?component';
    import TopLeftIcon from '@/ai/assistent/assets/icons/assistant/position_tl.svg?component';
    import MiddleRightIcon from '@/ai/assistent/assets/icons/assistant/position_mr.svg?component';
    import MiddleLeftIcon from '@/ai/assistent/assets/icons/assistant/position_ml.svg?component';
    import BottomRightIcon from '@/ai/assistent/assets/icons/assistant/position_br.svg?component';
    import BottomLeftIcon from '@/ai/assistent/assets/icons/assistant/position_bl.svg?component';
    import BeamTopLeftIcon from '@/ai/assistent/assets/icons/assistant/floating_beam_top_left.svg?component';
    import BeamTopRightIcon from '@/ai/assistent/assets/icons/assistant/floating_beam_top_right.svg?component';
    import BeamBottomLeftIcon from '@/ai/assistent/assets/icons/assistant/floating_beam_bottom_left.svg?component';
    import BeamBottomRightIcon from '@/ai/assistent/assets/icons/assistant/floating_beam_bottom_right.svg?component';
    import FloatingBeamIcon from '@/ai/assistent/assets/icons/assistant/floating_beam.svg?component';
    import DesktopIcon from '@keyvue/one-material-icons/icons/desktop_windows.svg?component';
    import MobileIcon from '@keyvue/one-material-icons/icons/phone_android.svg?component';
    import SquareInfoIcon from '@keyvue/one-awesome-icons/icons/regular/square-info.svg?component';
    import { number } from 'yup';

    const props = defineProps<{ modelValue: Assistent }>();
    const emit = defineEmits<{
        (e: 'update:modelValue', value: Assistent): void;
    }>();

    const assistent = ref(props.modelValue) as Ref<Assistent>;
    const showDesktop = ref(true);

    const chatDialogInfo = ref<ExposedOverlay>();

    const isWidgetTypeIcon = computed(() => {
        if (showDesktop.value) {
            return assistent.value.widget.desktopType.equals(WidgetType.ICON);
        }
        return assistent.value.widget.mobileType.equals(WidgetType.ICON);
    });

    const beamOpenPercentage = ref(assistent.value.widget.beamDisplayAfterPercentage ?? 16);

    // v-model.number doesn't work with text-input, so we need to convert the value to a number
    const beamOpenPercentageNumberValue = computed(() => Number.parseFloat(beamOpenPercentage.value.toString()));

    watch(beamOpenPercentage, () => {
        assistent.value.widget.beamDisplayAfterPercentage = beamOpenPercentageNumberValue.value;
    });

    watch(props.modelValue, (value) => {
        assistent.value = value;
    });

    watch(assistent, (value: Assistent) => {
        emit('update:modelValue', value);
    }, { deep: true });

    const widgetPosition = computed({
        get() {
            return showDesktop.value
                ? assistent.value.widget.desktopPosition
                : assistent.value.widget.mobilePosition;
        },
        set(newValue) {
            if (showDesktop.value) {
                assistent.value.widget.desktopPosition = newValue;
            } else {
                assistent.value.widget.mobilePosition = newValue;
            }
        },
    });

    const widgetVariation = computed({
        get() {
            return showDesktop.value
                ? assistent.value.widget.desktopVariant
                : assistent.value.widget.mobileVariant;
        },
        set(newValue) {
            if (showDesktop.value) {
                assistent.value.widget.desktopVariant = newValue;
            } else {
                assistent.value.widget.mobileVariant = newValue;
            }
        },
    });

    const widgetType = computed({
        get() {
            return showDesktop.value
                ? assistent.value.widget.desktopType
                : assistent.value.widget.mobileType;
        },
        set(newValue) {
            if (showDesktop.value) {
                assistent.value.widget.desktopType = newValue;

                switch (newValue.value) {
                    case WidgetType.ICON.value:
                        assistent.value.widget.desktopPosition = Position.BOTTOM_RIGHT;
                        break;
                    case WidgetType.FLOATING_BEAM.value:
                        assistent.value.widget.desktopPosition = Position.TOP_RIGHT;
                        break;
                    default:
                        assistent.value.widget.desktopPosition = Position.BOTTOM_RIGHT;
                        break;
                }
            } else {
                assistent.value.widget.mobileType = newValue;

                switch (newValue.value) {
                    case WidgetType.ICON.value:
                        assistent.value.widget.mobilePosition = Position.BOTTOM_RIGHT;
                        break;
                    case WidgetType.FLOATING_BEAM.value:
                        assistent.value.widget.mobilePosition = Position.TOP_RIGHT;
                        break;
                    default:
                        assistent.value.widget.mobilePosition = Position.BOTTOM_RIGHT;
                        break;
                }
            }
        },
    });

    const chatStyle = computed({
        get() {
            return showDesktop.value
                ? assistent.value.widget.desktopChatStyle
                : assistent.value.widget.mobileChatStyle;
        },
        set(newValue) {
            if (showDesktop.value) {
                assistent.value.widget.desktopChatStyle = newValue;
            } else {
                assistent.value.widget.mobileChatStyle = newValue;
            }
        },
    });

    function iconForVariant(variant: string) {
        switch (variant) {
            case Variant.ROUND.value: return BubbleIcon;
            case Variant.SQUARE.value: return ChatButtonIcon;
            case Variant.ROUNDED_SQUARE.value: return RoundedSquareIcon;
            case Variant.CORNERED_CIRCLE.value: return CorneredCircleIcon;
            default: return BubbleIcon;
        }
    }

    function tiltIcon(variant: Variant, position: Position) {
        const noTiltIcons = [
            Variant.ROUND.value,
            Variant.ROUNDED_SQUARE.value,
        ];

        if (noTiltIcons.includes(variant.value)) {
            return {};
        }

        if (Variant.CORNERED_CIRCLE.equals(variant.value)) {
            return {
                [Position.BOTTOM_LEFT.value]: { '--rotation': '90deg' },
                [Position.LEFT.value]: { '--rotation': '180deg' },
                [Position.TOP_LEFT.value]: { '--rotation': '180deg' },
                [Position.BOTTOM_RIGHT.value]: { '--rotation': '0deg' },
                [Position.RIGHT.value]: { '--rotation': '270deg' },
                [Position.TOP_RIGHT.value]: { '--rotation': '270deg' },
            }[position.value];
        }

        if (
            position.value.includes(Position.BOTTOM_LEFT.value)
            || position.value.includes(Position.BOTTOM_RIGHT.value)
        ) {
            return {};
        }

        if (position.value.includes(Position.RIGHT.value)) {
            return { transform: 'rotate(-90deg)' };
        }

        if (position.value.includes(Position.LEFT.value)) {
            return { transform: 'rotate(90deg)' };
        }

        return {};
    }

    const floatingBeamPositionTop = computed(() => {
        return widgetPosition.value.equals(Position.TOP_LEFT) || widgetPosition.value.equals(Position.TOP_RIGHT);
    });
</script>

<style scoped lang="scss">
.desktop-view-form {
    width: 100%;

    &__layout {
        width: 100%;
        height: 30vh;
        overflow: hidden;
        border-radius: size(sm);
        box-sizing: border-box;
        position: relative;

        border: 3px solid white;
        background-color: color(gray-100);

        & > svg {
            z-index: 1;
            box-shadow: 2px 2px 5px 5px #eee;
        }

        &::before {
            content: "";
            position: absolute;
            inset: 0;
            background-color: white;
            clip-path: polygon(0% 35%, 39.5% 35%, 39.5% 0%, 40.5% 0%, 40.5% 35%, 100% 35%, 100% 36%, 40.5% 36%, 40.5% 69%, 100% 69%, 100% 70%, 0% 70%, 0% 69%, 39.5% 69%,39.5% 36%, 0% 36%);
        }
    }
}

.chat-dialog-style-image {
    object-fit: contain;
    max-width: 300px;
    border: 1px solid color(gray-200);
    border-radius: 6px;
    box-shadow: 0 0 6px 0.2px lightgrey;
}

.top-left {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
}

.top {
    display: flex;
    align-items: flex-start;
    justify-content: center;
}

.top-right {
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
}

.bottom-left {
    display: flex;
    align-items: flex-end;
    justify-content: flex-start;
}

.bottom {
    display: flex;
    align-items: flex-end;
    justify-content: center;
}

.bottom-right {
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
}

.left {
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.center {
    display: flex;
    align-items: center;
    justify-content: center;
}

.right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
}
</style>
